import { PatientListPage } from '@features/patients';

export const PatientsView = () => {
  return <PatientListPage />;
};
